export default "__VITE_ASSET__DydLRM8M__"